// extracted by mini-css-extract-plugin
export default {"wrapper":"Cv-z","button":"Dv-z","alternate":"Ev-z","disabled":"Fv-z","paymentWarning":"Gv-z","fadeIn":"Hv-z"};